const emptyPerformance = {
  total: 0,
  active: 0,
  autoExpired: 0,
  expired: 0,
  pending: 0,
  rejected: 0,
};

export default emptyPerformance;
